import { ConvexProvider as SharedConvexProvider } from "@repo/app-shell"
import { authClient } from "@repo/db"
import type { ReactNode } from "react"

import { convexClient } from "../lib/convex"

export function ConvexProvider({ children }: { children: ReactNode }) {
  return (
    <SharedConvexProvider client={convexClient} authClient={authClient}>
      {children}
    </SharedConvexProvider>
  )
}
